import React, { Component } from 'react';
import { Form, Input, Col, Row, Modal } from 'antd';

const FormItem = Form.Item;

class BaseForm extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  submit = e => {
    if (e) {
      e.preventDefault();
    }

    const { handleSubmit, detail } = this.props;
    this.props.form.validateFields((err, values) => {
      if (!err) {
        if (detail.uuid) {
          values.uuid = detail.uuid;
        }
        handleSubmit(values);
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const ItemLayout2 = {
      labelCol: { span: 8 },
      wrapperCol: { span: 12 },
    };
    const { handleModalVisible, detail } = this.props;

    return (
      <Modal
        title={detail.uuid ? '编辑线索' : '新增线索'}
        visible
        onCancel={() => handleModalVisible(false)}
        onOk={this.submit}
      >
        <Form onSubmit={this.submit}>
          <Row>
            <Col span={24}>
              <FormItem label="名称" {...ItemLayout2}>
                {getFieldDecorator('name', {
                  rules: [{ required: true, message: '请输入线索名称!' }],
                  initialValue: detail.name,
                })(<Input />)}
              </FormItem>
            </Col>
            <Col span={24}>
              <FormItem label="联系人名称" {...ItemLayout2}>
                {getFieldDecorator('contactName', {
                  rules: [{ required: true, message: '请选择联系人名称!' }],
                  initialValue: detail.contactName,
                })(<Input />)}
              </FormItem>
            </Col>
            <Col span={24}>
              <FormItem label="联系人电话" {...ItemLayout2}>
                {getFieldDecorator('contactTel', {
                  rules: [{ required: true, message: '请选择联系人电话!' }],
                  initialValue: detail.contactTel,
                })(<Input />)}
              </FormItem>
            </Col>
          </Row>
        </Form>
      </Modal>
    );
  }
}

export default Form.create({ wrappedComponentRef: true })(BaseForm);



// WEBPACK FOOTER //
// ./src/components/crm/thread/ModalThread.js